// test1755
(1755 && 0);
